import utils from '../utils/utils';


export default {
    /**
     * https://docs.initia.xyz/developers/developer-guides/vm-specific-tutorials/evm/address-conversion#address-format-conversion
     * 
     * @param {*} address 
     * @param {*} currency 
     * @param {*} networkType 
     * @returns boolean
     */
    isValidAddress(address, currency, networkType) {
        try {
            const decoded = utils.bech32.decode(address);
            return decoded.hrp === 'init' && decoded.data.length === 32;
        } catch (error) {
            return false;
        }
    },
};
